import {Utils} from '@astek/utils';
import {PressureRange} from './pressure-range';

export class BaselineParametersResults {

  constructor(
    public basal: PressureRange,
  ) {
  }

  public equals(other: BaselineParametersResults | null): boolean {
    return Utils.isNullOrUndefined(other) &&
      this.basal.equals(other!.basal);
  }

}
